import {Api, HTTPMethod, buildExport} from "@next/apiconfig"

export class PrsApi implements Api {
    baseURL = ``
    version = "v1"
    endpoints = {
        getPrsData: {
            routeDefinition: "",
            getLocalURL: () => "",
            getRemoteURL: () => "",
            method: HTTPMethod.get,
        },
    }
}

const prsApi = new PrsApi()
export default (endpoint: keyof typeof prsApi.endpoints) => buildExport(prsApi, endpoint)
